var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogoYellowBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 106.5,
    fill: "#FFD956"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.5,
    cy: 106.5,
    r: 106.5,
    fill: "#FFD956"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7661 134.22L97.2639 144.718C175.892 98.5688 160.82 52.8197 160.82 52.8197C160.82 52.8197 115.032 37.7471 68.9217 116.376L79.4195 126.873",
    fill: "#171630"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7661 134.22L97.2639 144.718C175.892 98.5688 160.82 52.8197 160.82 52.8197C160.82 52.8197 115.032 37.7471 68.9217 116.376L79.4195 126.873",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5212 145.118C66.4913 143.088 66.4776 139.815 68.4908 137.802L108.025 98.2674C108.332 97.9607 108.736 97.7891 109.178 97.7716L116.235 95.6639C117.236 95.6296 118.048 96.4416 118.014 97.4426L115.906 104.5C115.889 104.942 115.717 105.346 115.41 105.653L75.876 145.187C73.8242 147.162 70.5512 147.148 68.5212 145.118Z",
    fill: "#FFD956",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.172 68.6963L88.4159 67.8826C88.4159 67.8826 60.2177 78.7971 54.9432 106.768C54.9432 106.768 67.3858 94.1712 78.7537 100.938",
    fill: "#171630"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.172 68.6963L88.4159 67.8826C88.4159 67.8826 60.2177 78.7971 54.9432 106.768C54.9432 106.768 67.3858 94.1712 78.7537 100.938",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.944 105.467L145.757 125.224C145.757 125.224 134.843 153.422 106.871 158.697C106.871 158.697 119.469 146.254 112.702 134.886",
    fill: "#171630"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.944 105.467L145.757 125.224C145.757 125.224 134.843 153.422 106.871 158.697C106.871 158.697 119.469 146.254 112.702 134.886",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M123.888 88.8229C128.832 93.7665 136.814 93.7997 141.717 88.897C146.619 83.9944 146.586 76.0124 141.643 71.0688C136.699 66.1252 128.717 66.0921 123.814 70.9947C118.912 75.8974 118.945 83.8793 123.888 88.8229Z",
    fill: "#FFD956",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8662 120.32L66.2707 126.915L72.8246 133.469",
    fill: "#171630"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8662 120.32L66.2707 126.915L72.8246 133.469",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3191 140.661L86.8372 147.369L80.1724 140.928",
    fill: "#171630"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3191 140.661L86.8372 147.369L80.1724 140.928",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.171 141.841L87.7411 135.22L94.3201 141.748",
    fill: "#171630"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.171 141.841L87.7411 135.22L94.3201 141.748",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9435 122.03L77.5212 126.657L71.6041 133.791",
    fill: "#171630"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9435 122.03L77.5212 126.657L71.6041 133.791",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3545 134.427L51.0425 145.739",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8984 150.869L50.5169 158.251",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4639 151.536L68.1519 162.848",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0078 156.979L56.6262 164.36",
    stroke: "#171630",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogoYellowBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-yellow-black.f4ed2221c7d2a68a9cad19ed0f3c34c4.svg";